import { h } from 'preact'
import Scrollchor from "preact-scrollchor"
// github.com/ltetzlaff/preact-scrollchor
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const PostSlide = (props) => {

  let post = props.post
  let title  = post.title.rendered
  let styles = post.product_style_names.join(', ')
  let image = post.product_image

  return (
    <div className="c-product-slide c-product-slider__slide js-product-slide">
      <Scrollchor to={`#${post.slug}`}>

        <div className="c-product-slide__image" dangerouslySetInnerHTML={{ __html: image }} />
        <div className="c-product-slide__header">
          <p className="c-product-slide__styles" dangerouslySetInnerHTML={{ __html: styles }} />
          <h3 className="c-product-slide__title" dangerouslySetInnerHTML={{ __html: title }} />
        </div>

      </Scrollchor>
    </div>
  )
}

export default PostSlide



// WEBPACK FOOTER //
// ./src/js/products/components/PostSlide.js